<template>
  <div class="Management">
    <div class="top">
      <div class="action" @click="onCreate">
        <p>Create User</p>
        <i class="el-icon-circle-plus"></i>
      </div>
    </div>

    <BackendList :list="backend_list" @update="onUpdate"></BackendList>

    <el-dialog
        title="Create User"
        custom-class="popup_user"
        :visible.sync="dialog_visible"
        width="30%">
      <BackendCreate v-if="dialog_visible" uid="" @update="onUpdate"></BackendCreate>
    </el-dialog>
  </div>
</template>

<script>
  import BackendList from "@/components/Management/BackendList/BackendList";
  import BackendCreate from "@/components/Management/BackendCreate/BackendCreate";
  import {getBackendUser} from "@/utils/api";

  export default {
    props: {},
    components:{
      BackendList,
      BackendCreate
    },
    data: () => {
      return {
        dialog_visible:false,
        backend_list:[]
      }
    },
    methods: {
      onUpdate(){
        this.dialog_visible = false;
        getBackendUser('').then(res => {
        this.backend_list = res.backend_list
      })
      },
      onCreate(){
        this.dialog_visible = true
      }
    },
    beforeMount(){
      getBackendUser('').then(res => {
        this.backend_list = res.backend_list
      })
    },
  };

</script>

<style lang="scss">
  @import "_Management.scss";
</style>